<template>
    <div>
        <table class="min-w-full divide-y divide-gray-200">
            <tbody >
                <tr v-for="document in documentsStore.searchResults">
                    <td>
                        <DocumentRow :document="document" :isSearchResult="true" />
                    </td>
                </tr>
            </tbody>
          </table>
    </div>
</template>

<script>
import { useDocumentsStore } from '../../stores/documentsStore';
import { mapStores } from 'pinia';
import DocumentRow from './DocumentRow.vue';

export default {
    components: {
        DocumentRow
    },
    computed: {
        ...mapStores(useDocumentsStore)
    },
}
</script>